<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.adjustment_log") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                template(v-if="searchAll")
                  .col-2.pl-0
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-calendar
                      date-picker.form-control-sm.text-center(
                        ref="startDate"
                        :config="localeDate"
                        v-model="startDate"
                        :disabled="loading"
                        @input="getListing()"
                      )
                template(v-else)
                  DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-md-3.col-2.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  DebounceInput(autofocus type="text" v-model="searchOperatorID" :placeholder="$t('ui.operator_id')" @enter="getListing()" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="searchOperatorID.length > 0")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchMemberID" :placeholder="$t('ui.member_id')" @enter="getListing()" size="sm")
              .form-group.col-md-3.col-2.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.amount') }}
                  b-form-select(v-model="filterAmount" @change="getListing()" :disabled="loading" size="sm")
                    option(value="1") {{ $t('ui.all') }}
                    option(value="2") {{ $t('ui.credit') }}
                    option(value="3") {{ $t("ui.debit") }}
              .form-group.col-md-3.col-2
                .d-inline-block.mr-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend" :title="$t('ui.signup_bonus')")
                      span {{ $t('ui.signup_bonus') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="signupBonus" @change="getListing()")
                        span.custom-switch-indicator 
                template(v-if="!isOperator")
                  .d-inline-block
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend" :title="$t('ui.search_all')")
                        span {{ $t('ui.search_all') }}
                      b-input-group-text(slot="append")
                        label.custom-switch
                          input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="searchAll" @change="searchAllOperator()")
                          span.custom-switch-indicator 
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListing()"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcelFull(v-if="logList.length > 0" mode="AdjustmentLog" :dttbl="logList" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_one").mr-2
                jsonToExcelFull(v-if="logListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="AdjustmentLog" :dttbl="logListFull" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_all")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="10%" @click="sortOrder('member_id')")
                          span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                          .float-right
                            i(:class="changeSortKey('member_id')")
                        th(width="10%" v-if="!isOperator")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                        th.text-right(width="10%" @click="sortOrder('amount')")
                          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                          .float-right
                            i(:class="changeSortKey('amount')")
                        th.text-right(width="10%")
                          span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                        th(width="20%" @click="sortOrder('remark')")
                          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                          .float-right
                            i(:class="changeSortKey('remark')")
                        th(width="13%" @click="sortOrder('created_by')")
                          span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                          .float-right
                            i(:class="changeSortKey('created_by')")
                        th.text-right(width="14%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="logList.length == 0")
                        td(:colspan="!isOperator ? '9' : '8'").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in logList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.member_id") {{ item.member_id }}
                        td(v-if="!isOperator")
                          span(:title="item.parent_id") {{ item.parent_id }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td
                          span(:title="item.created_by") {{ item.created_by }}
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      tr(v-if="showTotal")
                        td.text-right(:colspan="!isOperator ? '4' : '3'")
                          span.d-block {{ $t("ui.sub_total") }}
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                        td(colspan="4")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcelFull
  },
  data: () => ({
    loading2: false,
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    logListFull: [],
    logList: [],
    searchOperatorID: "",
    searchMemberID: "",
    startDate: null,
    endDate: null,
    dateRange: {
      startDate: null,
      endDate: null
    },
    localeDate: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "created_date",
    sortType: "desc",
    showTotal: false,
    subTotalAmount: 0,
    grandTotalAmount: 0,
    signupBonus: false,
    searchAll: false,
    filterAmount: 1
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    // operatorID() {
    //   return this.$store.getters.selectedOperatorID
    // },
    isEditAccess() {
      return this.$helpers.showActionButton("e_adjustmentlog");
    }
  },
  mounted: function() {
    this.startDate = this.$moment(new Date).format('YYYY-MM-DD')
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    if(this.isOperator) {
      this.searchOperatorID = this.accountID
      this.getListing();
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    searchAllOperator() {
      this.searchOperatorID = ""
      this.searchMemberID = ""
      this.filterAmount = 1
      this.signupBonus = false
      this.getListing()
    },
    getListing() {
      this.getLogList(true);
      if (this.$helpers.showExportAll(this.dateRange) == true)
        this.getLogListFull();
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListing();
    },
    getLogListFull: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.adjustmentListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchOperatorID,
          member_id: this.searchMemberID,
          is_sb: this.signupBonus,
          search_all: this.searchAll,
          filter_amount: this.filterAmount,          
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        if(this.searchAll) {
          json.start_date = this.startDate
          json.end_date = this.startDate
        } else {
          json.start_date = this.dateRange.startDate
          json.end_date = this.dateRange.endDate
        }

        if (this.searchMemberID.trim() != '')
          json.member_id = this.searchMemberID;

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logListFull = response.data.dt;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.adjustmentListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchOperatorID,
          member_id: this.searchMemberID,
          is_sb: this.signupBonus,
          search_all: this.searchAll,
          filter_amount: this.filterAmount,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if(this.searchAll) {
          json.start_date = this.startDate
          json.end_date = this.startDate
        } else {
          json.start_date = this.dateRange.startDate
          json.end_date = this.dateRange.endDate
        }

        if (this.searchMemberID.trim() != '')
          json.member_id = this.searchMemberID;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.showTotal = true;
                    response.data.dt.forEach(value => {
                      this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
                    });

                    this.logList = response.data.dt;
                    this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                    this.grandTotalAmount = this.logList.length > 0 ? this.logList[0].total_amount : 0;
                  }
                  else {
                    this.clearTotal();
                  }
                } else {
                  this.clearTotal();
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.logList = [];
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.logList = []
      this.totalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>